// extracted by mini-css-extract-plugin
export default {"wrapper":"SetUpPasswordCard_wrapper__qAjoR","title":"SetUpPasswordCard_title__Yg6w9","regularTitle":"SetUpPasswordCard_regularTitle__nZqTA"};